export default __webpack_public_path__ + "static/media/img-03.298adf25.jpg";